module.exports = __webpack_public_path__ + "static/media/approve-stamp.baa52a58.png";